export const GET_POST_NEW = "GET_POST_NEW";
export const GET_MASTER_INVENTORY = "GET_MASTER_INVENTORY";
